<div [ngClass]="{ 'upload-file-wrapper': isDataFile || isDocumentFile }">
  <div class="heading-title">{{ fileBrowse.uploadHeader }}</div>
  <div class="heading-desc">
    <a [ngClass]="{ 'disabled-download-file': fileAttachementID === undefined }" (click)="downloadFile()" aria-hidden="true">{{ fileBrowse.downloadTemplatelink }}</a>
    <span class="download-template-text"> {{ fileBrowse.downloadTemplateDesc }}</span>
  </div>
  @if (isDataFile) {
    <mat-form-field id="select-file-type" class="upload-data-files-dropdown">
      <mat-select placeholder="Select Document Category" [(ngModel)]="selectedFileType" (selectionChange)="onChange($event)" tabindex="0" role="button" (keyup.enter)="$event.target.click()">
        @for (file of fileTypes; track file) {
          <mat-option role="option" id="{{ file.value }}" [value]="file.value">
            {{ file.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  <span class="position-relative info-wrapper">
    @if (isDataFile) {
      <img class="dataFileInfo hover-element" src="../../../../assets/img/warning-icon.svg" alt="File Info" width="24px" height="24px" />
    }
    <app-popover-tooltip [popoverText]="dataFileInfoText" class="upload-info"></app-popover-tooltip>
  </span>
  <form [formGroup]="fileUploadForm">
    <div class="file-upload-section outline" draggable="true" (drop)="onDrop($event)" (dragover)="onFileDragOver($event)" (dragleave)="onFiledragOver = !onFiledragOver" [ngClass]="{ outline: onFiledragOver }">
      <p class="file-drag-text">{{ fileBrowse.dragDropText }}</p>
      <img src="../../../../../assets/img/cloud-up.svg" alt="Cloud Upload" />
      <p class="file-format-text">{{ fileBrowse.fileValidationTest }}</p>
      <input id="browseFile" type="file" [attr.accept]="isDocumentFile ? null : '.csv'" formControlName="file" hidden #uploadFile (change)="browseFile($event)" />
      <button mat-flat-button class="browse-btn" (click)="uploadFile.click()">Browse</button>
      @if (fileName) {
        <div class="file-name">
          &nbsp; <span class="icon-pin attachment-icon"></span> {{ fileName }} &nbsp;&nbsp;
          <span class="icon-shape close-icon" (click)="removeFile()" tabindex="0" role="button" (keyup.enter)="$event.target.click()"></span>
          @if (!isDocumentFile) {
            <p class="file-format-text file-rename-text">
              {{ fileTextMessage }}
            </p>
          }
        </div>
      }
    </div>
    @if (!isDocumentFile) {
      <div class="test-file-section float-right" tabindex="0" (keyup.enter)="$event.target.querySelector('input')?.click()">
        <span class="test-file-text test-file-status" id="testFileLabel"
          >Test File? &nbsp;
          <span class="test-file-status">{{ fileUploadForm.value.testFile ? 'Yes' : ' No' }}</span>
        </span>
        <mat-slide-toggle id="testFile" formControlName="testFile" #testFileStatus class="example-margin remember-me" aria-labelledby="testFileLabel"> </mat-slide-toggle>
      </div>
    }
    @if (isDocumentFile && onFiledragOver) {
      <mat-form-field class="file-description" appearance="fill">
        <mat-label>File Description</mat-label>
        <input id="file-secription" appHighlight matInput formControlName="fileDescription" maxlength="256" />
      </mat-form-field>
    }
  </form>
</div>
<div
  class="text-right"
  [ngClass]="{
    'content-footer ': isDataFile || isDocumentFile,
    'content-footer-enroll': !isDataFile && !isDocumentFile,
    'content-footer-verify-posting': isVerifyPosting,
  }"
>
  <button mat-flat-button class="mat-secondary mr-4" id="uploadFileCancelBtn" type="button" (click)="onCancel()" [ngClass]="{ 'ml-0': isDataFile || isDocumentFile }">Cancel</button>
  <button id="uploadFileUploadBtn" mat-flat-button class="mat-primary" [ngClass]="{ 'mat-flat-button': isError || fileUploadForm.valid }" [disabled]="isDisable()" (click)="upload(fileUploadForm.value)" data-cy="upload">Upload</button>
</div>
